// HOOKS
import { useMutation } from "@apollo/client";
// GRAPHQL
import { DELETE_PRODUCT } from "../../graphql/mutations/products/products.mutations";

const useDeleteProduct = () => {
  const [deleteProductMutation, { loading, error, data }] =
    useMutation(DELETE_PRODUCT);

  const deleteProduct = async (product) => {
    try {
      await deleteProductMutation(product);
      return data.deleteProduct;
    } catch (error) {
      console.error(`Error deleting product: ${error?.message}`);
      alert(`Error deleting product: ${error?.message}`);
    }
  };

  return { deleteProduct, loading, error };
};

export default useDeleteProduct;
